// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2083":"cc00fa56","2519":"2c90259a"}[chunkId] + ".chunk.css";
};